{
	"activity": {
		"call_title": "Il bando",
		"counters": {
			"acknowledged": "Viste",
			"awaiting_review": "Da vedere",
			"awaiting_student_number": "In attesa della matricola",
			"direct": "Ricevute via PEC diretta",
			"open_flags": "Segnalazioni da chiudere",
			"pending_verifications": "Verifiche in attesa",
			"superseded": "Sostituite",
			"title": "Le domande",
			"valid": "Valide",
			"with_problem": "Con un problema",
			"withdrawn": "Ritirate"
		},
		"dates_not_set": "Date da impostare",
		"nav": {
			"activity": "Attività",
			"applications": "Domande",
			"arrivals": "Ingressi",
			"call": "Bando",
			"flags": "Segnalazioni",
			"flags_open_one": "{{count}} segnalazione da chiudere",
			"flags_open_other": "{{count}} segnalazioni da chiudere",
			"label": "Pagine della struttura",
			"offers": "Offerte",
			"ranking": "Graduatoria",
			"verifications_pending_one": "{{count}} verifica da completare",
			"verifications_pending_other": "{{count}} verifiche da completare"
		},
		"news": {
			"mark_seen": "Segna come vista",
			"mark_seen_for": "Segna come vista la domanda protocollo {{protocol}}",
			"replacement": "La domanda protocollo {{protocol}} è stata sostituita da una nuova domanda",
			"restored": "La domanda protocollo {{protocol}} è di nuovo valida",
			"title": "Novità",
			"withdrawal": "La domanda protocollo {{protocol}} è stata ritirata dallo studente"
		},
		"page_title": "Attività",
		"period": "Dal {{start}} al {{close}}",
		"tasks": {
			"approve_ranking": "Controlla e approva la graduatoria",
			"confirm_data": "Conferma i dati della struttura",
			"confirm_mailbox_test": "Leggi l'email di prova nella PEC del bando e conferma il codice",
			"confirm_offer_expiries_one": "Conferma {{count}} decadenza di un'offerta senza risposta, o registra la risposta arrivata in tempo",
			"confirm_offer_expiries_other": "Conferma {{count}} decadenze di offerte senza risposta, o registra le risposte arrivate in tempo",
			"dsu_quota_below_threshold_one": "La quota DSU è sotto soglia: manca {{count}} posto a tariffa DSU",
			"dsu_quota_below_threshold_other": "La quota DSU è sotto soglia: mancano {{count}} posti a tariffa DSU",
			"due": "Entro il {{date}}",
			"due_end_of_day": "Scadenza: {{date}} alle 24:00",
			"empty": "Nessuna attività in attesa",
			"open": "Apri",
			"read_notices_one": "Guarda {{count}} novità sulle domande",
			"read_notices_other": "Guarda {{count}} novità sulle domande",
			"resend_bounced_offers_one": "Invia di nuovo {{count}} offerta non arrivata allo studente",
			"resend_bounced_offers_other": "Invia di nuovo {{count}} offerte non arrivate agli studenti",
			"resolve_flags_one": "Chiudi {{count}} segnalazione sui requisiti",
			"resolve_flags_other": "Chiudi {{count}} segnalazioni sui requisiti",
			"review_applications_one": "Leggi {{count}} domanda arrivata nella PEC e conferma che è valida",
			"review_applications_other": "Leggi {{count}} domande arrivate nella PEC e conferma che sono valide",
			"send_offers_by_pec_one": "Invia dalla PEC della struttura {{count}} offerta e registra l'orario della ricevuta",
			"send_offers_by_pec_other": "Invia dalla PEC della struttura {{count}} offerte e registra l'orario delle ricevute",
			"title": "Attività in attesa",
			"upload_direct_applications": "Controlla la PEC della struttura e carica le domande dirette",
			"verifications_pending_one": "Verifica i documenti di {{count}} assegnatario che ha accettato",
			"verifications_pending_other": "Verifica i documenti di {{count}} assegnatari che hanno accettato"
		}
	},
	"applications": {
		"phase": {
			"full": "Nessun posto libero: le domande riaprono da sole se un posto si libera.",
			"remaining": "Aperte: gli studenti fanno domanda finché resta un posto libero.",
			"stopped": "Fermate il {{when}}."
		},
		"resume": "Riapri le domande",
		"resumed": "Domande riaperte.",
		"stop": "Ferma le domande",
		"stopped": "Domande fermate.",
		"title": "Domande sui posti rimasti"
	},
	"calls": {
		"empty": "Non hai ancora creato un bando. Crealo con \"Nuovo bando\" su una delle tue strutture.",
		"new": {
			"button": "Nuovo bando",
			"choose": "Scegli una struttura",
			"create": "Crea il bando",
			"description": "Scegli la struttura e quando si aprono e chiudono le domande.",
			"none": "Tutte le tue strutture hanno già un bando.",
			"residence": "Struttura",
			"title": "Nuovo bando"
		},
		"page_title": "Bandi"
	},
	"corrections": {
		"contract_save": "Salva i dati del contratto",
		"contract_saved": "Dati del contratto corretti sul bando: le prossime offerte li riportano così.",
		"funded_beds": {
			"note": "Non cambia il bando pubblicato: serve alla quota DSU, che ne copre almeno il 30%.",
			"save": "Salva i posti ammessi a finanziamento",
			"saved": "Posti ammessi a finanziamento corretti sul bando.",
			"title": "Posti ammessi a finanziamento"
		},
		"intro": "Il bando pubblicato tiene la copia dei dati con cui è uscito. Qui correggi i dati del contratto e, per l'admin generale, i posti ammessi a finanziamento: la correzione vale per questo bando e non cambia la struttura, da cui nasce il bando dopo.",
		"title": "Correzioni del bando"
	},
	"data": {
		"call_link": "Bando sul sito",
		"cap": "Tetto quota 70%",
		"deposit": "Deposito",
		"double_rate": "{{rate}} doppia",
		"dsu_rate": "Tariffa DSU",
		"equipped": "Camere attrezzate",
		"funded": "Posti finanziati",
		"holder": "Intestatario",
		"institutions": "Atenei",
		"no_rate": "tariffa da inserire",
		"operator": "Gestore",
		"pec": "PEC",
		"quota_double_one": "{{count}} posto in camera doppia, {{rate}}",
		"quota_double_other": "{{count}} posti in camera doppia, {{rate}}",
		"quota_single_one": "{{count}} posto in camera singola, {{rate}}",
		"quota_single_other": "{{count}} posti in camera singola, {{rate}}",
		"rate_month": "{{rate}} al mese",
		"required_missing": "Manca: serve per pubblicare",
		"services": "Servizi",
		"signing": "Firma",
		"signing_days_one": "Entro {{count}} giorno dall'accettazione",
		"signing_days_other": "Entro {{count}} giorni dall'accettazione",
		"single_rate": "{{rate}} singola",
		"site_address": "Indirizzo",
		"site_bathrooms": "Servizi igienici",
		"site_equipped": "Posti attrezzati",
		"site_kitchens": "Cucine",
		"site_seats": "Posti",
		"site_seats_value": "{{single}} in camera singola, {{double}} in camera doppia",
		"site_services": "Altri servizi",
		"site_title": "Sede {{number}}: {{name}}",
		"site_typology": "Tipologia",
		"tab_contract": "Contratto e pagamenti",
		"tab_privacy": "DPO e email per informazioni",
		"tab_residence": "Struttura e servizi",
		"tab_seats": "Posti e tariffe",
		"tab_sites": "Sedi",
		"total": "Posti in tutto"
	},
	"dates": {
		"change_until_open": "Puoi cambiarle finché le domande non si aprono.",
		"close": "Chiusura",
		"close_time": "Le domande chiudono alle {{time}} del giorno di fine, ora italiana.",
		"closes_on": "Le domande chiudono {{day}} alle {{time}}, ora italiana.",
		"edit": "Modifica date",
		"end_day": "Giorno di fine",
		"errors": {
			"end_before_start": "Il bando chiuderebbe prima di aprirsi: scegli un giorno di fine successivo.",
			"invalid": "Quell'ora non esiste per il cambio dell'ora legale: scegli un'altra ora.",
			"locked": "Il bando è aperto: le date non si cambiano più.",
			"missing": "Compila giorno e ora di inizio e giorno di fine.",
			"start_in_past": "L'inizio è già passato: scegli una data futura."
		},
		"save": "Salva le date",
		"saved": "Date salvate.",
		"start": "Inizio",
		"start_day": "Giorno di inizio",
		"start_time": "Ora di inizio",
		"title": "Date del bando",
		"until": "fino a"
	},
	"document": {
		"download": "Scarica il bando (PDF)"
	},
	"figures": {
		"closes": "chiude {{when}}",
		"opens": "si apre {{when}}",
		"period": "Periodo",
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"mailbox_test": {
		"code": "Codice dell'email di prova",
		"code_format": "Il codice ha 6 cifre.",
		"confirmed": "Casella verificata il {{date}}.",
		"help": "Le domande arrivano alla PEC del bando come email normali. Se l'email di prova non arriva, controlla con il tuo fornitore che la casella accetti messaggi da indirizzi non PEC.",
		"no_address": "Manca l'indirizzo PEC del bando: inseriscilo con \"Modifica i dati\".",
		"none": "Non hai ancora mandato l'email di prova a {{address}}. Le domande arrivano a quell'indirizzo come email normali: la prova verifica che la casella le accetti.",
		"refused": "La casella ha respinto l'email: controlla che accetti la posta normale, poi mandane un'altra.",
		"send": "Invia l'email di prova",
		"send_again": "Invia di nuovo",
		"sent": "Email di prova inviata. Cercala nella PEC del bando.",
		"submit": "Conferma il codice",
		"title": "Prova della PEC del bando",
		"voided": "Codice sbagliato cinque volte: la prova è annullata. Invia di nuovo l'email di prova.",
		"waiting": "L'email di prova è partita per {{address}}. Aprila nella PEC e inserisci qui il codice.",
		"wrong_code_one": "Codice non corretto. Tentativi rimasti: {{count}}",
		"wrong_code_other": "Codice non corretto. Tentativi rimasti: {{count}}"
	},
	"preview": {
		"open": "Anteprima pagina struttura"
	},
	"previous_year": {
		"go": "Vai al bando {{year}} per fermare le domande",
		"go_offers": "Vai al bando {{year}} per chiudere le offerte",
		"reason": "Il bando {{previous}} accetta ancora domande sui posti rimasti. Ferma le domande per pubblicare il bando {{year}}.",
		"reason_offers": "Il bando {{previous}} ha ancora offerte in attesa di risposta o un ricalcolo da fare. Chiudi le offerte per pubblicare il bando {{year}}."
	},
	"proof": {
		"label": "Prova",
		"too_large": "Il file supera i 25 MB.",
		"upload_failed": "Non è stato possibile caricare il file. Riprova.",
		"uploading": "Caricamento in corso"
	},
	"publish": {
		"blockers": {
			"end_before_start": "La chiusura viene prima dell'inizio.",
			"start_in_past": "L'inizio è già passato: scegli una data futura."
		},
		"button": "Pubblica",
		"closed_title": "Domande chiuse",
		"confirm_button": "Pubblica il bando",
		"confirm_data": "Ho controllato i dati della struttura.",
		"confirm_data_blocked": "Prima completa e sistema i dati della struttura.",
		"confirm_data_voided": "I dati sono cambiati il {{date}}: controllali di nuovo e conferma.",
		"confirm_description": "Le date devono coincidere con quelle del bando ufficiale pubblicato sul sito della struttura. Dopo la pubblicazione regole e dati non cambiano più; le date si possono modificare fino all'apertura.",
		"confirm_title": "Pubblicare il bando?",
		"copy_ranking_url": "Copia l'indirizzo della graduatoria",
		"open_title": "Domande aperte",
		"published": "Bando pubblicato.",
		"published_at": "Pubblicato il",
		"published_title": "Bando pubblicato",
		"ranking_url": "Graduatoria pubblica",
		"ranking_url_copied": "Indirizzo copiato."
	},
	"residence": {
		"data_complete": "Dati della struttura completi",
		"edit": "Modifica i dati",
		"empty": "Non indicato",
		"go_to_call": "Vai al bando",
		"next_call_note": "Le modifiche valgono per il prossimo bando: il bando {{year}} resta com'è. I dati del contratto e i posti ammessi a finanziamento di quel bando si correggono nella sua pagina.",
		"page_intro": "Puoi salvare anche a metà.",
		"quota70": {
			"error": "Non siamo riusciti a caricare la lista quota 70%. Riprova.",
			"open_ranking": "Apri la graduatoria",
			"waits": "La lista compare quando la graduatoria è calcolata, dopo la chiusura del bando."
		},
		"saved": "Dati della struttura salvati. Ricordati di confermarli di nuovo prima di pubblicare.",
		"saved_next_call": "Dati della struttura salvati: valgono per il prossimo bando.",
		"tabs": {
			"quota70": "Quota 70%"
		},
		"title": "Dati della struttura"
	},
	"residences": {
		"applications": "Domande",
		"dates_not_set": "Date da impostare",
		"empty": "Non hai ancora strutture: l'admin generale te ne affida una con un'email.",
		"next": {
			"closed": "Chiuso: niente da fare per ora",
			"confirm_data": "Conferma i dati della struttura",
			"data_invalid": "Alcuni dati della struttura non tornano: sistemali nei dati della struttura",
			"mailbox_test": "Invia l'email di prova alla PEC del bando",
			"open": "Domande aperte: si chiude da solo",
			"privacy_contacts": "Mancano il DPO o l'email per informazioni: completali nei dati della struttura",
			"published": "Pubblicato: si apre da solo all'inizio",
			"rate_references": "Mancano tariffa DSU e tetto: inseriscili nei dati della struttura",
			"ready": "Pronto da pubblicare",
			"set_dates": "Imposta le date del bando",
			"sites": "Mancano dati delle sedi: completali nei dati della struttura"
		},
		"notices_one": "{{count}} novità sulle domande",
		"notices_other": "{{count}} novità sulle domande",
		"period": "Periodo del bando:"
	},
	"status": {
		"draft_one": "Manca {{count}} passo alla pubblicazione",
		"draft_other": "Mancano {{count}} passi alla pubblicazione",
		"ready": "Pronto da pubblicare"
	},
	"steps": {
		"data_check": "I dati qui sotto finiscono nel bando: controllali, correggili se serve, poi conferma.",
		"data_missing": "Mancano dei dati o qualcosa non torna: completali con \"Modifica i dati\".",
		"data_title": "Controlla i dati",
		"dates_hint": "Scegli quando si aprono le domande e il giorno in cui chiudono."
	},
	"structures": {
		"call": "Bando",
		"data_complete": "Dati completi",
		"data_missing": "Da completare: {{items}}",
		"intro": "Completa i dati di ogni struttura: sono quelli con cui si scrive il bando. Poi crea il bando da \"Bandi\".",
		"missing": {
			"data_invalid": "dati che non tornano",
			"privacy_contacts": "DPO o email per informazioni",
			"rate_references": "tariffe di riferimento",
			"sites": "sedi"
		},
		"no_call": "Nessun bando",
		"no_city": "Sede da inserire",
		"page_title": "Strutture"
	},
	"years": {
		"label": "Anno accademico",
		"option": "Anno accademico {{year}}",
		"read_only": "Bando {{year}} in sola lettura: si vede tutto, ma non si cambia niente.",
		"read_only_short": "Sola lettura"
	}
}
